import { render, staticRenderFns } from "./BannerModel.vue?vue&type=template&id=00be00be&scoped=true&"
import script from "./BannerModel.vue?vue&type=script&lang=js&"
export * from "./BannerModel.vue?vue&type=script&lang=js&"
import style0 from "./BannerModel.vue?vue&type=style&index=0&id=00be00be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be00be",
  null
  
)

export default component.exports